module.exports = __webpack_public_path__ + "static/media/faq-icon5.8b9a123a.png";